import {z} from 'zod';
import {FEATURE_FLAGS} from '@packages/systems/feature-config/shared';
import {defineToolRegistryManifest} from '../types/base-tool-types';

const toolName = 'get-workflow-execution-status' as const;

const argumentZod = z.object({
  execution_id: z
    .string()
    .describe('Unique identifier of the workflow execution to check.'),
});

export const getWorkflowExecutionStatusManifest = defineToolRegistryManifest({
  id: toolName,
  prettyName: 'Get workflow execution status',
  family: 'workflows',
  llmTool: {
    name: toolName,
    description:
      'Gets the status of an AI workflow execution. Returns status, start/stop times, and whether the execution has finished. Use this to poll after calling execute-workflow until isFinished is true.',
    inputSchema: argumentZod,
  },
  type: 'server',
  featureGate: FEATURE_FLAGS.AIA_WORKFLOWS_MCP,
  confirmBeforeExecuting: false,
});

export type GetWorkflowExecutionStatusArgumentType = z.infer<
  typeof argumentZod
>;
